import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAllocatedViewLoading: true,
  allocatedViewData: [],
  isAllocatedViewLegendOpen: false
};

const allocatedSlice = createSlice({
  name: "allocatedSlice",
  initialState,
  reducers: {
    setIsAllocatedViewLegendOpen: (state, action) => {
      state.isAllocatedViewLegendOpen = action.payload;
    },
    setAllocatedViewData: (state, action) => {
      state.allocatedViewData = action.payload;
    },
    setIsAllocatedViewLoading: (state, action) => {
      state.isAllocatedViewLoading = action.payload;
    }
  }
});

export default allocatedSlice.reducer;

export const {
  setIsAllocatedViewLegendOpen,
  setAllocatedViewData,
  setIsAllocatedViewLoading
} = allocatedSlice.actions;
